import React from 'react';
import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import moment from 'moment'
import * as Actions from './actions'
import { cloneDeep } from 'lodash';

// JOB OFFER LIST ACTIONS/ACTION OPERATIONS
export const getListJobOffer = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { jobOfferList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateJobOFFerList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const applySearchFilters = (searcModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(0))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searcModel))

    // get data from server and update results
    dispatch(getListJobOffer())
}

export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListJobOffer())
}

export const resetFilters = () => (dispach, getState) => {
    dispach(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { jobOfferList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListJobOffer())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListJobOffer())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListJobOffer())
}

// Job Offer ADD ACTION OPERATIONS
export const createJobOffer = (data) => (dispatch, getState) => {
    const { jobOfferAdd: { alert } } = getState()
    let nAlert = { ...alert }

    dispatch(Actions.showLoading(true))

    return ApiService.post(Path.ROOT, data)
        .then((response) => {
            if (response) {
                let title = 'Create Success'
                const { message } = response.data
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed'
                    goBackToList = false
                }
                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
            dispatch(Actions.hideShowModal(false, 'confirm'))
        })
}

export const getHolidayDates = (company) => (dispatch) => {
    dispatch(Actions.showLoading(true));
    return ApiService.get(Path.GET_HOLIDAY_DATES, { company })
        .then((response) => {
            let listData = response ? response.data.map(date => moment(date).format("YYYY-MM-DD")) : [];
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
        });
};

// Job Offer DETAIL/UPDATE ACTION OPERATIONS
export const exportJobOfferReport = (filename) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { jobOfferList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId

    return ApiService.export(Path.EXPORT, filename, updateSortModel)
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const updateJobOffer = (data) => (dispatch, getState) => {
    const { jobOfferAdd: { alert } } = getState()
    let nAlert = { ...alert }

    dispatch(Actions.showLoading(true))

    return ApiService.put(`${Path.ROOT}/${data.ID}`, data)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                const { message } = response.data
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    goBackToList = false
                }
                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
            dispatch(Actions.hideShowModal(false, 'confirm'))
            dispatch(Actions.hideShowModal(false, 'info'))
        })
}

//GET
export const getInterviewResultById = (applicant, mode) => (dispatch) => {
    dispatch(Actions.hasAddLoaded(false))
    return ApiService.get(`${Path.RESULT}/${applicant}`)
        .then((response) => {
            dispatch(Actions.setJobOfferAdd(response.data, mode))
            return response.data;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasAddLoaded(true))
        })
}

export const getJobOfferResultById = (applicant, mode) => (dispatch) => {
    dispatch(Actions.hasAddLoaded(false))
    return ApiService.get(`${Path.JORESULT}/${applicant}`)
        .then((response) => {
            dispatch(Actions.setJobOfferAdd(response.data, mode))
            return response.data;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasAddLoaded(true))
        })
}

export const getJOApprovalStatus = () => async (dispatch, getState) => {
    dispatch(Actions.hasAddLoaded(false))
    let data;

     try {
            const response = await ApiService.get(Path.JO_APPROVAL_STATUS);
            if (response) {
                data = response.data;
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(Actions.hasAddLoaded(true));
        }
    
        return data;
}

export const getAcceptedStatusName = () => async (dispatch, getState) => {
    dispatch(Actions.hasAddLoaded(false))
    let data;

     try {
            const response = await ApiService.get(Path.JOB_OFFER_STATUS);
            if (response) {
                data = response.data;
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(Actions.hasAddLoaded(true));
        }
    
        return data;
}